import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { Toaster } from "sonner";
import { PaperPlaneTilt, Cards, ClockCounterClockwise, Envelope } from "@phosphor-icons/react";
import Compose from "@/pages/Compose";
import Templates from "@/pages/Templates";
import History from "@/pages/History";

const navItems = [
  { to: "/", label: "Compose", icon: PaperPlaneTilt, testid: "sidebar-compose-link", end: true },
  { to: "/templates", label: "Templates", icon: Cards, testid: "sidebar-templates-link" },
  { to: "/history", label: "History", icon: ClockCounterClockwise, testid: "sidebar-history-link" },
];

const Sidebar = () => (
  <aside className="w-64 shrink-0 border-r border-border bg-card flex-col hidden md:flex" data-testid="sidebar">
    <div className="px-6 py-7 border-b border-border flex items-center gap-3">
      <div className="h-9 w-9 rounded-md bg-primary text-primary-foreground flex items-center justify-center">
        <Envelope size={20} weight="fill" />
      </div>
      <div>
        <p className="font-display text-lg leading-none tracking-tight">Postmark</p>
        <p className="text-xs text-muted-foreground mt-1 font-mono">no-smtp mailer</p>
      </div>
    </div>
    <nav className="flex-1 px-3 py-5 space-y-1">
      {navItems.map(({ to, label, icon: Icon, testid, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={testid}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
              isActive
                ? "bg-primary text-primary-foreground"
                : "text-foreground hover:bg-secondary"
            }`
          }
        >
          <Icon size={18} weight="regular" />
          {label}
        </NavLink>
      ))}
    </nav>
    <div className="px-6 py-5 border-t border-border">
      <p className="text-xs text-muted-foreground leading-relaxed">
        Emails delivered over an HTTP API. No SMTP servers, no ports.
      </p>
    </div>
  </aside>
);

const MobileNav = () => (
  <nav className="md:hidden flex items-center gap-1 border-b border-border bg-card px-3 py-2 sticky top-0 z-20">
    {navItems.map(({ to, label, icon: Icon, testid, end }) => (
      <NavLink
        key={to}
        to={to}
        end={end}
        data-testid={`${testid}-mobile`}
        className={({ isActive }) =>
          `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
            isActive ? "bg-primary text-primary-foreground" : "text-foreground"
          }`
        }
      >
        <Icon size={17} />
        {label}
      </NavLink>
    ))}
  </nav>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="flex min-h-screen">
          <Sidebar />
          <div className="flex-1 flex flex-col min-w-0">
            <MobileNav />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Compose />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/history" element={<History />} />
              </Routes>
            </main>
          </div>
        </div>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
